import formDetail from './form-detail.vue'

export default formDetail
